import {
  ArrowRight,
  Bath,
  BedDouble,
  BookOpen,
  Calendar,
  ChevronDown,
  ChevronUp,
  CircleChevronDown,
  ExternalLink,
  Gavel,
  Home,
  LineChart,
  MapPin,
  Menu,
  Minus,
  Phone,
  Plus,
  X,
  type LucideIcon,
} from "lucide-react";

const icons = {
  arrow_forward: ArrowRight,
  menu_book: BookOpen,
  gavel: Gavel,
  location_on: MapPin,
  call: Phone,
  stacked_line_chart: LineChart,
  home: Home,
  calendar_month: Calendar,
  open_in_new: ExternalLink,
  king_bed: BedDouble,
  bathtub: Bath,
  expand_less: ChevronUp,
  expand_more: ChevronDown,
  add: Plus,
  remove: Minus,
  expand_circle_down: CircleChevronDown,
  menu: Menu,
  close: X,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
}

export default function Icon({
  name,
  className = "",
  size = 24,
}: IconProps): JSX.Element {
  const Cmp = icons[name];
  return <Cmp className={className} size={size} aria-hidden strokeWidth={1.75} />;
}
